








































































import { Component, Watch } from 'vue-property-decorator'
import api from "../../api/index"
import Lists from '../components/Lists.vue'
const moment = require('moment')

@Component
export default class Accesslist extends Lists {
  isLoading = true
  dataType = 'admins'
  accesses = []

  currentAccessId:any = null

  wordSearched = ""

  head() {
    return {
      title: 'Utilisateurs',
      meta: [{
        breadcrumb: 'Utilisateurs'
      }]
    }
  }

  get totalRows() {
    return this.accesses.length < this.perPage ? this.accesses.length : this.perPage
  }

  goToAccess(row:any) {
    const accessId = row.id
    this.$router.push({ name: 'accessProfile', params: { accessId }, query: { condominiumId: row.condominium.id } })
  }

  @Watch('perPage')
  @Watch('wordSearched')
  @Watch('currentPage')
  onSearchPropsChanged(val: any, old: any) {
    if ((old && val && val.toString() === old.toString()) || this.isLoading) {
      return
    }
    this.getAllAccesses()
  }

  async fetchData() {
    this.getAllAccesses()
  }

  async getAllAccesses() {
    try {
      const res = await api.get("bo/groups", { params: {
        page: this.currentPage,
        per_page: this.perPage,
        keywords: this.wordSearched,
        order: this.sortField,
        order_desc: this.sortOrder
      }})
      this.totalPages = parseInt(res.headers["x-pagination-total-pages"])
      this.totalResults = parseInt(res.headers["x-pagination-total"])
      this.perPage = parseInt(res.headers["x-pagination-per-page"])

      this.accesses = res.data
    } catch (e) {
      if (e.response.status !== 200) {
        console.log(e.response.status)
      }
    }
  }

  async mounted() {
    await api.setToken()
    this.isLoading = true
    await this.getAllAccesses()
    this.isLoading = false
  }

  async sendAccessInvitation(invitation:any) {
    try {
      const res = await api.post("bo/accesses/" + this.currentAccessId + "/invitations", {invitation})
      this.$toast.open({
        message: "L'invitation a bien été envoyée",
        type: 'is-novaccess-purple',
        duration: 2000,
      })
      var id = this.currentAccessId.toString()
      this.$router.push({ name: 'accessProfile', params: { accessId: id }})
    } catch (e) {
      if (e.response.status === 201) {
        console.log(e.response.status)
      }
    }
  }
}
